import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { AddMemberFlowSelectionCardI } from '@core/tellent-types';
import { HeadingComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tla-user-invitation-flow-selection-card',
  imports: [IconComponent, HeadingComponent],
  templateUrl: './user-invitation-flow-selection-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-invitation-flow-selection-card.component.less',
})
export class UserInvitationFlowSelectionCardComponent {
  public card = input.required<AddMemberFlowSelectionCardI>();

  public cardClick = output<any>();
}
